'use strict';

(function () {
  'use strict';

  angular.module('msTracker', ['chart.js', 'translations', 'ngAnimate', 'msCore', 'msActivities', 'highcharts-ng']);
})();